import { useEffect } from 'react';
import SelectField from '../../../components/Forms/Input/SelectField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { usePaymentMethod } from '../../../hooks/usePaymentMethod';
// import { useAllowedOptions } from '../../../hooks/settings/useAllowedOptions';
import CreditAmountSection from '../../Sales/PaymentConditionSection/sections/CreditAmountSection';
import OtherPaymentSection from '../../Sales/PaymentConditionSection/sections/OtherPaymentSection';
import BankDraftPaymentSection from '../../Sales/PaymentConditionSection/sections/BankDraftPaymentSection';
import AccountsReceivablePaymentSection from '../../Sales/PaymentConditionSection/sections/AccountsReceivablePaymentSection';
import CryptoPaymentSection from '../../Sales/PaymentConditionSection/sections/CryptoPaymentSection';
import BitcoinPaymentSection from '../../Sales/PaymentConditionSection/sections/BitcoinPaymentSection';
import EWalletPaymentSection from '../../Sales/PaymentConditionSection/sections/EWalletPaymentSection';
import ElectronicMoneyPaymentSection from '../../Sales/PaymentConditionSection/sections/ElectronicMoneyPaymentSection';
import BankTransferPaymentSection from '../../Sales/PaymentConditionSection/sections/BankTransferPaymentSection';
import CheckPaymentSection from '../../Sales/PaymentConditionSection/sections/CheckPaymentSection';
import CreditCardPaymentSection from '../../Sales/PaymentConditionSection/sections/CreditCardPaymentSection';
import DebitCardPaymentSection from '../../Sales/PaymentConditionSection/sections/DebitCardPaymentSection';
import CashPaymentSection from '../../Sales/PaymentConditionSection/sections/CashPaymentSection';

const PurchasePaymentMethodSelector = () => {
  const {
    form,
    updateField,
    updateIndividualPayments,
    clearIndividualPayments,
    purchaseSettlementLoaded,
  } = useBasePurchase();
  const { paymentMethodDropdown, fetchPaymentMethodDropdown } =
    usePaymentMethod();
  // const { getCodes, fetchCodesByModuleAndTarget } = useAllowedOptions();

  const selectedMethodCode = form.paymentMethod?.code;
  const totalToPay = form.total ?? 0;

  // valores de pagos individuales
  const cashReceived = form.individualPayments?.cash?.amountReceived ?? '';

  useEffect(() => {
    fetchPaymentMethodDropdown();
    // fetchCodesByModuleAndTarget('PURCHASES', 'PAYMENT_METHOD');
  }, []);

  // const allowedPaymentMethodCodes = getCodes('PURCHASES', 'PAYMENT_METHOD');

  // const filteredPaymentMethods = paymentMethodDropdown.filter((method) =>
  //   allowedPaymentMethodCodes.includes(method.code)
  // );

  // if(purchaseSettlementLoaded) return null;

  return (
    <div className="space-y-4">
      {/* Título */}
      <div>
        <h4 className="text-md font-semibold text-black dark:text-white">
          Forma de Pago
        </h4>
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          Selecciona el método de pago aplicado a esta compra. Se mostrarán
          campos adicionales según la opción.
        </p>
      </div>

      {/* Monto total */}
      <div className="bg-gray-100 dark:bg-gray-800 rounded-md py-2">
        <p className="text-gray-700 dark:text-gray-200 text-sm font-semibold">
          Total a Pagar:{' '}
          <span className="text-black dark:text-white">
            ${totalToPay.toFixed(2)}
          </span>
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-2">
        <SelectField
          name="paymentMethod"
          label="Forma de Pago"
          iconKey="payment"
          value={form.paymentMethod?.id || ''}
          onChange={(e) => {
            const selected = paymentMethodDropdown.find(
              (opt) => String(opt.id) === String(e.target.value)
            );
            if (selected) {
              updateField('paymentMethod', {
                id: selected.id,
                name: selected.name,
                code: selected.code,
              });
              clearIndividualPayments();
            } else {
              updateField('paymentMethod', null);
              clearIndividualPayments();
            }
          }}
          disabled={purchaseSettlementLoaded}
          options={paymentMethodDropdown.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
        />
      </div>

      {!purchaseSettlementLoaded && (
        <>
          {/* Render dinámico */}
          {selectedMethodCode === '01' && (
            <CashPaymentSection
              cashReceived={cashReceived}
              onCashChange={(val) => {
                const amountReceived = val === '' ? undefined : val;
                const computedChange =
                  amountReceived !== undefined
                    ? Number((amountReceived - totalToPay).toFixed(2))
                    : 0;

                updateIndividualPayments({
                  cash: {
                    amountReceived,
                    change: computedChange,
                  },
                });
              }}
              totalToPay={totalToPay}
            />
          )}

          {selectedMethodCode === '02' && (
            <DebitCardPaymentSection
              voucherCode={form.individualPayments?.debitCard?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ debitCard: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '03' && (
            <CreditCardPaymentSection
              voucherCode={form.individualPayments?.creditCard?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ creditCard: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '04' && (
            <CheckPaymentSection
              voucherCode={form.individualPayments?.check?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ check: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '05' && (
            <BankTransferPaymentSection
              voucherCode={
                form.individualPayments?.bankTransfer?.reference ?? ''
              }
              onVoucherChange={(val) =>
                updateIndividualPayments({ bankTransfer: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '08' && (
            <ElectronicMoneyPaymentSection
              voucherCode={
                form.individualPayments?.electronicMoney?.reference ?? ''
              }
              onVoucherChange={(val) =>
                updateIndividualPayments({
                  electronicMoney: { reference: val },
                })
              }
            />
          )}

          {selectedMethodCode === '09' && (
            <EWalletPaymentSection
              voucherCode={form.individualPayments?.eWallet?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ eWallet: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '11' && (
            <BitcoinPaymentSection
              voucherCode={form.individualPayments?.bitcoin?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ bitcoin: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '12' && (
            <CryptoPaymentSection
              voucherCode={form.individualPayments?.crypto?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ crypto: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '13' && (
            <AccountsReceivablePaymentSection
              voucherCode={
                form.individualPayments?.accountsReceivable?.reference ?? ''
              }
              onVoucherChange={(val) =>
                updateIndividualPayments({
                  accountsReceivable: { reference: val },
                })
              }
            />
          )}

          {selectedMethodCode === '14' && (
            <BankDraftPaymentSection
              voucherCode={form.individualPayments?.bankDraft?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ bankDraft: { reference: val } })
              }
            />
          )}

          {selectedMethodCode === '99' && (
            <OtherPaymentSection
              voucherCode={form.individualPayments?.other?.reference ?? ''}
              onVoucherChange={(val) =>
                updateIndividualPayments({ other: { reference: val } })
              }
            />
          )}

          {/* Sección adicional de crédito (autorización de monto) */}
          {selectedMethodCode === '13' && (
            <CreditAmountSection
              creditAmount={
                form.individualPayments?.accountsReceivable?.authorizedAmount ??
                ''
              }
              onChange={(val) =>
                updateIndividualPayments({
                  accountsReceivable: {
                    ...form.individualPayments?.accountsReceivable,
                    authorizedAmount: val === '' ? undefined : val,
                  },
                })
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default PurchasePaymentMethodSelector;
